import { createAction, props } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { Process } from '../models/process.model';

export const setProcesses = createAction('[Processes Component] SetProcesses', props<Pagination<Process>>());

export const resetProcesses = createAction('[Processes Component] ResetProcesses');
